class ProductTab extends HTMLElement {
  constructor() {
    super();
    this.selectedVariants = {};
    this.productHandle = null
  }

  connectedCallback() {
    this.productHandle = this.dataset.productHandle
    const variantInputs = this.querySelectorAll('.product-tabs__variants .product-form__input');

    if (variantInputs.length > 0) {
      this.initializeSelectedVariants(variantInputs);
      this.bindVariantChangeEvents(variantInputs);
    }
  }

  initializeSelectedVariants(variantInputs) {
    variantInputs.forEach((input, index) => {
      const selectedOption = input.querySelector('option[selected]');
      const selectedValue = selectedOption ? selectedOption.value : '';
      this.selectedVariants[index] = selectedValue;
    });
  }

  bindVariantChangeEvents(variantInputs) {
    variantInputs.forEach((input, index) => {
      input.addEventListener('change', (event) => {
        this.selectedVariants[index] = event.target.value;

        this.updateProductInfo();
      });
    });
  }

  async updateProductInfo() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'products/' + this.productHandle + '.js');
  
      if (!response.ok) return;
  
      const product = await response.json();
  
      if (!product?.variants?.length) return;
  
      const matchedVariant = product.variants.find(variant => {
        return Object.entries(this.selectedVariants).every(([index, value]) => {
          return variant[`option${parseInt(index) + 1}`] === value;
        });
      });
  
      if (!matchedVariant) return;
      this.updateFormInput(matchedVariant.id);
      this.updatePrice(matchedVariant.price);
  
    } catch (error) {
      console.error(error);
    }
  }

  updateFormInput(updatedId) {
    const addToCartForm = this.querySelector('[data-type="add-to-cart-form"]');
    const variantInput = addToCartForm.querySelector('.product-variant-id');
    variantInput.value = updatedId
  }

  updatePrice(price) {
    const priceElement = this.querySelector('.price-item');
    if (!priceElement) {
      return;
    }

    const currency = window.Shopify?.currency?.active || 'USD';
    
    const shopLocale = window.Shopify?.locale || 'en';
    const countryCode = window.Shopify?.country || 'US';
    const locale = `${shopLocale}-${countryCode}`;

    const formattedPrice = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(price / 100);

    priceElement.textContent = formattedPrice;
  }
}

customElements.define('product-tab', ProductTab);